import { repositoryForSchema } from '../repository-for-schema';
import { createResolverPlugin } from './create-resolver-plugin';
export const singleRefPlugin = createResolverPlugin({
    alias: 'singleRef',
    buildFieldConfig: ({ propertyKey, meta, serverConfig, schemaBuilder }) => {
        const refSchema = meta.schema;
        return {
            type: schemaBuilder.getTypeFromSchema(refSchema),
            resolve: (source) => {
                const id = source[propertyKey];
                return repositoryForSchema(refSchema).findOne({ _id: id });
            },
        };
    },
});
